"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _constant = require("@airasia/phoenix-components/components/AmenitiesCard/constant");
var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _RoomCard = require("./RoomCard.propTypes");
var _ImageGalleryModal = _interopRequireDefault(require("./ImageGalleryModal"));
var _loadableComponents = _interopRequireDefault(require("loadable-components"));
var _AmenitiesCard = _interopRequireDefault(require("@airasia/phoenix-components/components/AmenitiesCard"));
var _AllAmenitiesModal = _interopRequireDefault(require("./AllAmenitiesModal"));
var _Utils = require("./Utils");
var _Camera = _interopRequireDefault(require("./Camera"));
var _constants = require("./constants");
var _RateDetailModal = _interopRequireDefault(require("./RateDetailModal"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var NotificationBannerInline = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"NotificationBannerInline" */"@airasia/phoenix-components/components/NotificationBannerInline"));
  });
});
var RoomCardMobile = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"RoomCardMobile" */"./RoomCardMobile"));
  });
});
var RateInfo = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"RateInfo" */"./RateInfo"));
  });
});
var Container = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__Container",
  componentId: "sc-1adc6cs-0"
})(["max-width:100%;box-shadow:0 1px 4px rgba(0,0,0,0.16);border-radius:", ";", " font-family:", ";border:1px solid ", ";"], function (_ref) {
  var theme = _ref.theme,
    move = _ref.move;
  return move ? theme.borderRadius.XXnormal : theme.borderRadius.normal;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.default;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.greyLight;
});
var RoomNameWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__RoomNameWrapper",
  componentId: "sc-1adc6cs-1"
})(["width:100%;background:", ";border-radius:", ";box-sizing:border-box;min-height:", ";display:flex;align-items:center;justify-content:space-between;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.backgroundColor.primary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.micro, " ").concat(theme.space.micro, " 0 0");
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.semiLarge;
});
var LowInventory = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__LowInventory",
  componentId: "sc-1adc6cs-2"
})(["width:228px;"]);
var RoomNameWrapperLeft = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__RoomNameWrapperLeft",
  componentId: "sc-1adc6cs-3"
})(["display:flex;align-items:center;"]);
var RoomNameWrapperRight = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__RoomNameWrapperRight",
  componentId: "sc-1adc6cs-4"
})(["display:flex;align-items:center;"]);
var ImageDarken = _styledComponents.default.image.withConfig({
  displayName: "NewRoomCard__ImageDarken",
  componentId: "sc-1adc6cs-5"
})(["opacity:0.7;background-color:'black';"]);
var ImageDarkenWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ImageDarkenWrapper",
  componentId: "sc-1adc6cs-6"
})(["flex:1 1 auto;height:60px;margin:0 1px;background:#000;opacity:1;width:'100%';height:200;cursor:pointer;"]);
var RoomName = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__RoomName",
  componentId: "sc-1adc6cs-7"
})(["color:", ";font-size:", ";line-height:", ";font-weight:", ";margin-right:", ";padding:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.neutral;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSize.titleSmall;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.lineHeight.XXLarge;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontWeight.medium;
}, function (_ref12) {
  var theme = _ref12.theme,
    isHasTag = _ref12.isHasTag,
    isMobile = _ref12.isMobile;
  return (
    // eslint-disable-next-line no-nested-ternary
    isHasTag ? isMobile ? theme.space.tiny : theme.space.XSmall : 0
  );
}, function (_ref13) {
  var theme = _ref13.theme;
  return "".concat(theme.space.small, " ").concat(theme.space.standard);
});
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__Wrapper",
  componentId: "sc-1adc6cs-8"
})(["display:flex;box-shadow:0px 1px 4px rgba(0,0,0,0.16);border-bottom:1px solid ", ";", " ", ""], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.greyLight;
}, function (_ref15) {
  var isMobile = _ref15.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref16) {
  var isMobile = _ref16.isMobile,
    highlight = _ref16.highlight,
    theme = _ref16.theme;
  return highlight && !isMobile ? "\n    border: 1px solid ".concat(theme.colors.secondary, ";\n    border-radius: 0 0 ").concat(theme.space.micro, " ").concat(theme.space.micro, ",\n    border-top: 0,\n    ") : "";
});
var ImagesWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ImagesWrapper",
  componentId: "sc-1adc6cs-9"
})(["width:400px;background-color:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.backgroundColor.greyLighter;
});
var HeroImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__HeroImageWrapper",
  componentId: "sc-1adc6cs-10"
})(["height:200px;margin-bottom:", ";position:relative;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.space.mini;
});
var ThumbnailImagesWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ThumbnailImagesWrapper",
  componentId: "sc-1adc6cs-11"
})(["display:flex;flex-wrap:wrap;margin:0 -1px;"]);
var ThumbnailImage = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ThumbnailImage",
  componentId: "sc-1adc6cs-12"
})(["flex:1 1 auto;height:60px;margin:0 1px;"]);
var AmenitiesWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__AmenitiesWrapper",
  componentId: "sc-1adc6cs-13"
})(["background-color:", ";"], function (_ref19) {
  var theme = _ref19.theme;
  return theme.backgroundColor.greyLighter;
});
var AmenityWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__AmenityWrapper",
  componentId: "sc-1adc6cs-14"
})(["padding-left:", ";padding-top:", ";padding-bottom:", ";"], function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.medium;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.small;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.XXXSmall;
});
var AmenityContainerRight = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__AmenityContainerRight",
  componentId: "sc-1adc6cs-15"
})(["float:right;width:50%;"]);
var AmenityContainerLeft = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__AmenityContainerLeft",
  componentId: "sc-1adc6cs-16"
})(["float:right;width:50%;"]);
var ShowAllAmenitiesLabel = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ShowAllAmenitiesLabel",
  componentId: "sc-1adc6cs-17"
})(["color:", ";display:flex;flex-direction:row;font-size:", ";font-weight:", ";font-family:", ";padding-top:0.5vw;cursor:pointer;"], function (_ref23) {
  var theme = _ref23.theme,
    move = _ref23.move;
  return move ? theme.colors.tertiaryRed : theme.colors.secondary;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.fontSize.XSmall;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.fontWeight.medium;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.fontFamily;
});
var ImagesAmountWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ImagesAmountWrapper",
  componentId: "sc-1adc6cs-18"
})(["position:absolute;transform:translate(24%,-179%);color:", ";font-size:", ";display:flex;align-items:center;border-radius:", ";cursor:pointer;"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.default;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.fontSize.XSmall;
}, function (_ref29) {
  var theme = _ref29.theme;
  return theme.borderRadius.XLarge;
});
var ImagesShowMoreAmountWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ImagesShowMoreAmountWrapper",
  componentId: "sc-1adc6cs-19"
})(["position:absolute;transform:translate(36%,-179%);color:", ";font-size:", ";display:flex;align-items:center;border-radius:", ";cursor:pointer;"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.colors.default;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontSize.XSmall;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.borderRadius.XLarge;
});
var ImagesAmountShowWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__ImagesAmountShowWrapper",
  componentId: "sc-1adc6cs-20"
})(["position:absolute;transform:translate(10%,-179%);color:", ";font-size:", ";display:flex;align-items:center;border-radius:", ";cursor:pointer;"], function (_ref33) {
  var theme = _ref33.theme;
  return theme.colors.default;
}, function (_ref34) {
  var theme = _ref34.theme;
  return theme.fontSize.XSmall;
}, function (_ref35) {
  var theme = _ref35.theme;
  return theme.borderRadius.XLarge;
});
var RoomInfoWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__RoomInfoWrapper",
  componentId: "sc-1adc6cs-21"
})(["width:82%;display:table;border-left:1px solid ", ";"], function (_ref36) {
  var theme = _ref36.theme;
  return theme.colors.greyLight;
});
var TagWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__TagWrapper",
  componentId: "sc-1adc6cs-22"
})(["background-color:", ";color:", ";padding:", ";font-size:", ";line-height:", ";border-radius:", ";font-weight:", ";margin-right:", ";"], function (_ref37) {
  var theme = _ref37.theme,
    backgroundColor = _ref37.backgroundColor;
  return !backgroundColor ? theme.backgroundColor.blueLight : theme.backgroundColor[backgroundColor];
}, function (_ref38) {
  var theme = _ref38.theme,
    color = _ref38.color;
  return !color ? theme.colors.secondary : theme.colors[color];
}, function (_ref39) {
  var theme = _ref39.theme;
  return theme.space.micro;
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.fontSize.XSmall;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.lineHeight.small;
}, function (_ref42) {
  var theme = _ref42.theme,
    borderRadius = _ref42.borderRadius;
  return !borderRadius ? theme.borderRadius.normal : theme.borderRadius[borderRadius];
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.fontWeight.medium;
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.space.micro;
});
var AmenityRowWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__AmenityRowWrapper",
  componentId: "sc-1adc6cs-23"
})(["color:", ";font-style:normal;font-weight:normal;line-height:", ";font-size:", ";line-height:", ";display:flex;align-items:center;padding:", ";"], function (_ref45) {
  var theme = _ref45.theme;
  return theme.colors.greyDarker;
}, function (_ref46) {
  var theme = _ref46.theme;
  return theme.lineHeight.XLarge;
}, function (_ref47) {
  var theme = _ref47.theme;
  return theme.fontSize.XSmall;
}, function (_ref48) {
  var theme = _ref48.theme;
  return theme.lineHeight.small;
}, function (_ref49) {
  var theme = _ref49.theme;
  return "".concat(theme.space.tiny, " 0");
});
var SeeAllAmenities = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__SeeAllAmenities",
  componentId: "sc-1adc6cs-24"
})(["float:left;color:", ";font-size:", ";", ";padding:", ";"], function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.greyDarker;
}, function (_ref51) {
  var theme = _ref51.theme;
  return theme.fontSize.XSmall;
}, function (_ref52) {
  var theme = _ref52.theme;
  return theme.fontFamily;
}, function (_ref53) {
  var theme = _ref53.theme;
  return "".concat(theme.space.tiny, " 0");
});
var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__IconWrapper",
  componentId: "sc-1adc6cs-25"
})(["font-size:25px;margin-top:-10px;padding-right:12px;"]);
var MorePhotosWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__MorePhotosWrapper",
  componentId: "sc-1adc6cs-26"
})(["display:flex;z-index:0;"]);
var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__LabelWrapper",
  componentId: "sc-1adc6cs-27"
})(["color:'#4C4C50';size:14px;margin-left:10px;"]);
var LowInventoryHotelRooms = _styledComponents.default.div.withConfig({
  displayName: "NewRoomCard__LowInventoryHotelRooms",
  componentId: "sc-1adc6cs-28"
})(["width:100%;height:26px;padding:4px 12px;border-radius:50px;border:1px solid #c94318;gap:5px;background:#c94318;display:flex;align-items:center;justify-content:center;font-family:'DM Sans';font-size:12px;font-weight:400;line-height:18px;letter-spacing:0em;text-align:right;color:#ffffff;margin-right:10px;padding-left:12px;padding-right:12px;"]);
var Amenity = function Amenity(_ref54) {
  var amenities = _ref54.amenities,
    allHotelAmenities = _ref54.allHotelAmenities,
    showMore = _ref54.showMore,
    move = _ref54.move,
    theme = _ref54.theme,
    isExtraRoomAmenitiesEnabled = _ref54.isExtraRoomAmenitiesEnabled;
  var showAble = amenities.slice(0, 7);
  var getPopoverTop = function getPopoverTop() {
    var top = 120;
    top += 33 * (Math.ceil(amenities.length / 4) - 1);
    return "-".concat(top, "px");
  };
  var halfway = Math.ceil(showAble.length / 2);
  var col1 = isExtraRoomAmenitiesEnabled ? showAble.filter(function (_, index) {
    return index % 2 === 0;
  }) : showAble.slice(0, halfway);
  var col2 = isExtraRoomAmenitiesEnabled ? showAble.filter(function (_, index) {
    return index % 2 !== 0;
  }) : showAble.slice(halfway);
  return /*#__PURE__*/_react.default.createElement(AmenityWrapper, null, /*#__PURE__*/_react.default.createElement(AmenityContainerLeft, {
    style: {
      float: 'left',
      width: '50%'
    }
  }, col1.map(function (amenity) {
    var iconName = (amenity === null || amenity === void 0 ? void 0 : amenity.displayId) && _constant.ROOM_AMENITIES_OTHER_ICONS[amenity === null || amenity === void 0 ? void 0 : amenity.displayId] || _constant.ICON_ROOM_AMENITIES[amenity === null || amenity === void 0 ? void 0 : amenity.id];
    return /*#__PURE__*/_react.default.createElement(AmenityRowWrapper, {
      key: "room-amenity-".concat(amenity.id)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: iconName,
      color: "#4C4C50",
      fontsize: "14px",
      width: "23.99",
      height: "23.99"
    }), /*#__PURE__*/_react.default.createElement(LabelWrapper, null, " ", amenity.name, " "));
  })), /*#__PURE__*/_react.default.createElement(AmenityContainerRight, {
    style: {
      float: 'right',
      width: '50%'
    }
  }, col2.map(function (amenity) {
    var iconName = (amenity === null || amenity === void 0 ? void 0 : amenity.displayId) && _constant.ROOM_AMENITIES_OTHER_ICONS[amenity === null || amenity === void 0 ? void 0 : amenity.displayId] || _constant.ICON_ROOM_AMENITIES[amenity === null || amenity === void 0 ? void 0 : amenity.id];
    return /*#__PURE__*/_react.default.createElement(AmenityRowWrapper, {
      key: "room-amenity-".concat(amenity.id)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: iconName,
      color: "#4C4C50",
      fontsize: "0.75rem"
    }), /*#__PURE__*/_react.default.createElement(LabelWrapper, null, " ", amenity.name, " "));
  })), /*#__PURE__*/_react.default.createElement(SeeAllAmenities, null, amenities.length > 7 && /*#__PURE__*/_react.default.createElement(_Popover.default, {
    theme: theme,
    left: "0",
    top: getPopoverTop(),
    marginLeft: "auto",
    padding: "24px",
    width: 700,
    position: "top",
    zIndex: 9,
    content: /*#__PURE__*/_react.default.createElement(_AmenitiesCard.default, {
      accessible: true,
      amenities: amenities,
      title: allHotelAmenities,
      iconConstent: _constant.ICON_ROOM_AMENITIES
    }),
    leftArrow: "30px",
    id: "room-amenities-popover",
    style: {
      fontSize: '12px'
    }
  }, /*#__PURE__*/_react.default.createElement(ShowAllAmenitiesLabel, {
    move: move
  }, ' ', /*#__PURE__*/_react.default.createElement(IconWrapper, null, " + "), showMore))));
};
Amenity.propTypes = _RoomCard.RoomCardPropTypes;
Amenity.defaultProps = _RoomCard.RoomCardDefaultValues;
var NewRoomCard = function NewRoomCard(_ref55) {
  var accessible = _ref55.accessible,
    id = _ref55.id,
    name = _ref55.name,
    isMobile = _ref55.isMobile,
    _ref55$images = _ref55.images,
    images = _ref55$images === void 0 ? [] : _ref55$images,
    _ref55$amenities = _ref55.amenities,
    amenities = _ref55$amenities === void 0 ? [] : _ref55$amenities,
    theme = _ref55.theme,
    heroImage = _ref55.heroImage,
    onLoadImage = _ref55.onLoadImage,
    isImageGalleryEnabled = _ref55.isImageGalleryEnabled,
    _ref55$translations = _ref55.translations,
    translations = _ref55$translations === void 0 ? {} : _ref55$translations,
    _ref55$occupancy = _ref55.occupancy,
    occupancy = _ref55$occupancy === void 0 ? {} : _ref55$occupancy,
    _ref55$rates = _ref55.rates,
    rates = _ref55$rates === void 0 ? [] : _ref55$rates,
    isShowRateName = _ref55.isShowRateName,
    onSelectRoom = _ref55.onSelectRoom,
    _ref55$address = _ref55.address,
    address = _ref55$address === void 0 ? {} : _ref55$address,
    locale = _ref55.locale,
    isSingleOption = _ref55.isSingleOption,
    _ref55$roomOccupancy = _ref55.roomOccupancy,
    roomOccupancy = _ref55$roomOccupancy === void 0 ? {} : _ref55$roomOccupancy,
    bigPointsFilter = _ref55.bigPointsFilter,
    withTooltip = _ref55.withTooltip,
    isSnap = _ref55.isSnap,
    bedGroupsOptions = _ref55.bedGroupsOptions,
    roomsLeft = _ref55.roomsLeft,
    showSleepsInfoSection = _ref55.showSleepsInfoSection,
    showIncludedInPriceInfo = _ref55.showIncludedInPriceInfo,
    rateDiscounts = _ref55.rateDiscounts,
    soldOutBedGroupTokens = _ref55.soldOutBedGroupTokens,
    lowInventoryFOMO = _ref55.lowInventoryFOMO,
    payNowMessage = _ref55.payNowMessage,
    isPayNowEnabled = _ref55.isPayNowEnabled,
    move = _ref55.move,
    getTranslatedPricebreakdownData = _ref55.getTranslatedPricebreakdownData,
    enableCombosavingsTag = _ref55.enableCombosavingsTag,
    bundleSavingsTag = _ref55.bundleSavingsTag,
    totalSummaryPax = _ref55.totalSummaryPax,
    orText = _ref55.orText,
    enableInstallmentOption = _ref55.enableInstallmentOption,
    isBlockedRateIsEnabled = _ref55.isBlockedRateIsEnabled,
    isExtraRoomAmenitiesEnabled = _ref55.isExtraRoomAmenitiesEnabled;
  var roomAmenityName = [];
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var thumbnailImages = images.slice(1, 4);
  var thumbnailImageWithCount = images.slice(3, 4);
  var roomRates = rates.slice(3);
  var allHotelAmenities = translations.allHotelAmenities,
    allText = translations.all,
    messageFOMO = translations.messageFOMO;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    isOpenImageGallery = _useState2[0],
    setIsOpenImageGallery = _useState2[1];
  var _ref56 = rates.length > 0 ? rates[0] : {},
    recommendedText = _ref56.recommendedText,
    flierDiscountText = _ref56.flierDiscountText;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    isOpenAllAmenitiesModal = _useState4[0],
    setIsOpenAllAmenitiesModal = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    isOpenRateDetailModal = _useState6[0],
    setIsOpenRateDetailModal = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    selectedRate = _useState8[0],
    setSelectedRate = _useState8[1];
  var roomAmenities = roomRates.filter(function (rate) {
    return rate.amenities.length > 0;
  });
  var openImageGallery = function openImageGallery() {
    setIsOpenImageGallery(true);
    if (isOpenAllAmenitiesModal) {
      setIsOpenAllAmenitiesModal(false);
    }
  };
  var onCloseImageGallery = function onCloseImageGallery() {
    setIsOpenImageGallery(false);
    if (document.getElementsByTagName('body')) {
      document.getElementsByTagName('body')[0].removeAttribute('style');
    }
  };
  var onCloseAllAmenitiesModal = function onCloseAllAmenitiesModal() {
    setIsOpenAllAmenitiesModal(false);
    if (document.getElementsByTagName('body')) {
      document.getElementsByTagName('body')[0].removeAttribute('style');
    }
  };
  var onCloseRateDetailModal = function onCloseRateDetailModal() {
    setIsOpenRateDetailModal(false);
    setSelectedRate({});
    if (document.getElementsByTagName('body')) {
      document.getElementsByTagName('body')[0].removeAttribute('style');
    }
  };
  var onSelectRoomHandler = function onSelectRoomHandler(rate) {
    if (isOpenRateDetailModal) {
      setIsOpenRateDetailModal(false);
    }
    onSelectRoom(_objectSpread({
      roomId: id
    }, rate));
  };
  var onShowRateDetailHandler = function onShowRateDetailHandler(rateId) {
    var rate = rates.find(function (item) {
      return item.id === rateId;
    });
    setSelectedRate(rate);
    setIsOpenRateDetailModal(true);
  };
  var getMain = function getMain(_ref57) {
    var imageList = _ref57.imageList;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isMobile ? /*#__PURE__*/_react.default.createElement(RoomCardMobile, {
      bigMembership: bigPointsFilter === null || bigPointsFilter === void 0 ? void 0 : bigPointsFilter.bigMembership,
      applyBigpoints: bigPointsFilter === null || bigPointsFilter === void 0 ? void 0 : bigPointsFilter.applyBigpoints,
      theme: theme,
      name: name,
      images: images,
      thumbnailImageWithCount: thumbnailImageWithCount,
      amenities: amenities,
      roomAmenityName: roomAmenityName,
      translations: translations,
      isImageGalleryEnabled: isImageGalleryEnabled,
      isMobile: isMobile,
      heroImage: heroImage,
      occupancy: occupancy,
      rates: rates,
      isShowRateName: isShowRateName,
      openImageGallery: function openImageGallery() {
        return setIsOpenImageGallery(true);
      },
      onSelectRoomHandler: onSelectRoomHandler,
      onShowAmenitiesHandler: function onShowAmenitiesHandler() {
        return setIsOpenAllAmenitiesModal(true);
      },
      onShowRateDetailHandler: onShowRateDetailHandler,
      locale: locale,
      isSingleOption: isSingleOption,
      roomOccupancy: roomOccupancy,
      isSnap: isSnap,
      bedGroupsOptions: bedGroupsOptions,
      roomsLeft: roomsLeft,
      rateDiscounts: rateDiscounts,
      soldOutBedGroupTokens: soldOutBedGroupTokens,
      lowInventoryFOMO: lowInventoryFOMO,
      isBlockedRateIsEnabled: isBlockedRateIsEnabled,
      move: move
    }) : /*#__PURE__*/_react.default.createElement(Container, {
      move: move
    }, /*#__PURE__*/_react.default.createElement(RoomNameWrapper, null, /*#__PURE__*/_react.default.createElement(RoomNameWrapperLeft, null, /*#__PURE__*/_react.default.createElement(RoomName, {
      isHasTag: ((0, _Utils.isNotEmpty)(recommendedText) || (0, _Utils.isNotEmpty)(flierDiscountText)) && isSingleOption
    }, name), isSingleOption && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(recommendedText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, recommendedText), (0, _Utils.isNotEmpty)(flierDiscountText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, flierDiscountText))), /*#__PURE__*/_react.default.createElement(RoomNameWrapperRight, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isMobile && roomsLeft && /*#__PURE__*/_react.default.createElement(LowInventory, null, /*#__PURE__*/_react.default.createElement(NotificationBannerInline, {
      accessible: true,
      border: false,
      closable: false,
      ctaColor: move ? 'tertiaryRed' : 'primaryDark',
      device: "desktop",
      fullWidth: true,
      message: roomsLeft,
      showLeftIcon: true,
      smallerPadding: false,
      textType: "sub",
      theme: theme,
      type: "error",
      largerPadding: true,
      move: move
    })), rates && lowInventoryFOMO && lowInventoryFOMO.message && /*#__PURE__*/_react.default.createElement(LowInventoryHotelRooms, null, lowInventoryFOMO.message)))), /*#__PURE__*/_react.default.createElement(Wrapper, {
      tabIndex: tabIndex
    }, /*#__PURE__*/_react.default.createElement(ImagesWrapper, null, isImageGalleryEnabled ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HeroImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage || _constants.PLACEHOLDER_IMAGE,
      alt: name,
      width: "100%",
      height: "100%",
      onLoad: onLoadImage,
      centerFocus: !!heroImage,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
    })), thumbnailImages.length > 1 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ThumbnailImagesWrapper, null, thumbnailImages.map(function (image, idx) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, thumbnailImages.length - 1 === idx ? /*#__PURE__*/_react.default.createElement(ImageDarkenWrapper, null, /*#__PURE__*/_react.default.createElement(ImageDarken, {
        onClick: openImageGallery
      }, /*#__PURE__*/_react.default.createElement(_Image.default, {
        src: image.links.small,
        width: "100%",
        height: "100%",
        alt: image.caption,
        centerFocus: true,
        enableProgressiveImageLoading: true,
        lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
      })), imageList.length === 4 && /*#__PURE__*/_react.default.createElement(ImagesAmountShowWrapper, {
        onClick: openImageGallery
      }, /*#__PURE__*/_react.default.createElement(_Camera.default, null), /*#__PURE__*/_react.default.createElement(_Label.default, {
        textColor: "default"
      }, "+ ", translations === null || translations === void 0 ? void 0 : translations.morePhoto)), imageList.length === 3 && /*#__PURE__*/_react.default.createElement(ImagesShowMoreAmountWrapper, {
        onClick: openImageGallery
      }, /*#__PURE__*/_react.default.createElement(_Camera.default, null), /*#__PURE__*/_react.default.createElement(_Label.default, {
        textColor: "default"
      }, "+ ", translations === null || translations === void 0 ? void 0 : translations.morePhoto)), /*#__PURE__*/_react.default.createElement(MorePhotosWrapper, null, imageList.length > 4 && /*#__PURE__*/_react.default.createElement(ImagesAmountWrapper, {
        onClick: openImageGallery
      }, /*#__PURE__*/_react.default.createElement(_Camera.default, null), /*#__PURE__*/_react.default.createElement(_Label.default, {
        textColor: "default"
      }, "+ ", imageList.length - 4, " ", translations === null || translations === void 0 ? void 0 : translations.photo)))) : /*#__PURE__*/_react.default.createElement(ThumbnailImage, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
        src: image.links.small,
        width: "100%",
        height: "100%",
        centerFocus: true,
        alt: image.caption || 'TBD',
        enableProgressiveImageLoading: true,
        lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
      })));
    })))) : /*#__PURE__*/_react.default.createElement(HeroImageWrapper, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
      src: heroImage || _constants.PLACEHOLDER_IMAGE,
      width: "100%",
      height: "100%",
      onLoad: onLoadImage,
      alt: name,
      centerFocus: !!heroImage,
      enableProgressiveImageLoading: true,
      lowResolutionImageUrl: _constants.PLACEHOLDER_IMAGE
    })), Array.isArray(amenities) && amenities.length > 0 && /*#__PURE__*/_react.default.createElement(AmenitiesWrapper, null, /*#__PURE__*/_react.default.createElement(Amenity, {
      amenities: amenities,
      showMore: translations.showMore,
      allHotelAmenities: allHotelAmenities,
      move: move,
      theme: theme,
      isExtraRoomAmenitiesEnabled: isExtraRoomAmenitiesEnabled
    }))), Array.isArray(rates) && rates.length > 0 && /*#__PURE__*/_react.default.createElement(RoomInfoWrapper, null, rates.map(function (rate, index) {
      var _getLowInventoryFomo, _rateObj$mainKey, _rate$discountData, _rateDiscounts$index, _rate$discountData2, _rateDiscounts$index2, _lowInventoryFOMO$rat;
      var rateObj = (_getLowInventoryFomo = (0, _Utils.getLowInventoryFomo)([lowInventoryFOMO], rate)) === null || _getLowInventoryFomo === void 0 ? void 0 : _getLowInventoryFomo.rate;
      var mainKey = Number(rate === null || rate === void 0 ? void 0 : rate.id);
      var nestedKey = Number(rate === null || rate === void 0 ? void 0 : rate.rateOptionId);
      var hasMainKey = rateObj && (0, _typeof2.default)(rateObj) === 'object' ? mainKey in rateObj : false;
      var hasNestedKey = hasMainKey && ((_rateObj$mainKey = rateObj[mainKey]) === null || _rateObj$mainKey === void 0 ? void 0 : _rateObj$mainKey.option) && nestedKey in rateObj[mainKey].option;
      return /*#__PURE__*/_react.default.createElement(RateInfo, {
        key: "rate-".concat(rate.id),
        rate: rate,
        isShowRateName: isShowRateName,
        index: index,
        translations: translations,
        withTooltip: withTooltip,
        occupancy: occupancy,
        onSelectRoomHandler: onSelectRoomHandler,
        locale: locale,
        isSingleOption: isSingleOption,
        promoTitle: rate !== null && rate !== void 0 && (_rate$discountData = rate.discountData) !== null && _rate$discountData !== void 0 && _rate$discountData.id ? (_rateDiscounts$index = rateDiscounts[index]) === null || _rateDiscounts$index === void 0 ? void 0 : _rateDiscounts$index.title : '',
        discountType: rate !== null && rate !== void 0 && (_rate$discountData2 = rate.discountData) !== null && _rate$discountData2 !== void 0 && _rate$discountData2.id ? (_rateDiscounts$index2 = rateDiscounts[index]) === null || _rateDiscounts$index2 === void 0 ? void 0 : _rateDiscounts$index2.type : '',
        roomAmenityName: roomAmenityName,
        roomOccupancy: roomOccupancy,
        isSnap: isSnap,
        bedGroupsOptions: bedGroupsOptions,
        includedInPriceHeader: roomAmenities.length > 0,
        showSleepsInfoSection: showSleepsInfoSection,
        showIncludedInPriceInfo: showIncludedInPriceInfo,
        messageFOMO: messageFOMO,
        lowInventoryFOMO: hasNestedKey && ((_lowInventoryFOMO$rat = lowInventoryFOMO.rate) === null || _lowInventoryFOMO$rat === void 0 || (_lowInventoryFOMO$rat = _lowInventoryFOMO$rat[Number(rate.id)]) === null || _lowInventoryFOMO$rat === void 0 ? void 0 : _lowInventoryFOMO$rat.option) || '',
        soldOutBedGroupTokens: soldOutBedGroupTokens,
        isBogoPromoEnabled: rate === null || rate === void 0 ? void 0 : rate.isBogoEnabled,
        bogoMessage: rate === null || rate === void 0 ? void 0 : rate.bogoMessage,
        bogoTag: rate === null || rate === void 0 ? void 0 : rate.bogoTag,
        payNowMessage: payNowMessage,
        isPayNowEnabled: isPayNowEnabled,
        move: move,
        isRM9PromoEnabled: rate === null || rate === void 0 ? void 0 : rate.isRM9PromoEnabled,
        accessible: accessible,
        getTranslatedPricebreakdownData: getTranslatedPricebreakdownData,
        enableCombosavingsTag: enableCombosavingsTag,
        bundleSavingsTag: bundleSavingsTag,
        totalSummaryPax: totalSummaryPax,
        isMobile: isMobile,
        orText: orText,
        enableInstallmentOption: enableInstallmentOption,
        isBlockedRateIsEnabled: isBlockedRateIsEnabled
      });
    })))), isOpenImageGallery && /*#__PURE__*/_react.default.createElement(_ImageGalleryModal.default, {
      isMobile: isMobile,
      images: imageList,
      name: name,
      amenities: amenities,
      theme: theme,
      onClose: onCloseImageGallery,
      address: address,
      allText: allText,
      isOpen: isOpenImageGallery,
      zIndex: isSnap ? 13 : 10,
      move: move
    }), isMobile && isOpenAllAmenitiesModal && /*#__PURE__*/_react.default.createElement(_AllAmenitiesModal.default, {
      isOpen: isOpenAllAmenitiesModal,
      onClose: onCloseAllAmenitiesModal,
      heroImage: heroImage,
      address: address,
      name: name,
      amenities: amenities,
      openImageGallery: openImageGallery,
      translations: translations,
      zIndex: isSnap ? 13 : 10
    }), isMobile && isOpenRateDetailModal && /*#__PURE__*/_react.default.createElement(_RateDetailModal.default, {
      isOpen: isOpenRateDetailModal,
      onClose: onCloseRateDetailModal,
      rate: selectedRate,
      heroImage: heroImage,
      address: address,
      onSelectRoomHandler: onSelectRoomHandler,
      name: name,
      translations: translations,
      zIndex: isSnap ? 13 : 10,
      isSnap: isSnap
    }));
  };
  getMain.propTypes = _RoomCard.getMainPropType;
  return themeContext ? getMain({
    imageList: images
  }) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain({
    imageList: images
  }));
};
NewRoomCard.propTypes = _RoomCard.RoomCardPropTypes;
NewRoomCard.defaultProps = _RoomCard.RoomCardDefaultValues;
var _default = NewRoomCard;
exports.default = _default;